import { Feature } from '@next/arable-lib/geo';

export interface ManualSoilAnalysis {
  id: number;
  description: string;
  samplingDateTime: string;
  characteristics: {
    carbonToNitrogenRatio: number;
    deliverableNitrogen: number;
    totalNitrogen: number;
    minNitrogen?: number;
    phosphorusAmmoniumLactate: number;
    phosphorusNumber: number;
    plantAvailablePhosphorus: number;
    potassiumNumber: number;
    plantAvailableMagnesium: number;
    calciumCarbonate: number;
    organicMatter: number;
    soilAcidityNir: number;
    soilAcidity: number;
    ammoniaStock: number;
    nitrateStock: number;
    plantAvailablePotassium: number;
    plantAvailableCalcium: number;
    calciumStock: number;
    copperStock: number;
    ferroStock: number;
    cationExchangeCapacity: number;
    calciumFilling: number;
    magnesiumFilling: number;
    potassiumFilling: number;
    sodiumFilling: number;
    soilAvailablePotassium: number;
    potassiumStock: number;
    cecClayHumus: number;
  };
}

export interface SoilAnalysis {
  id: number;
  ubn: string;
  description: string;
  borderData: Feature;
  labId: string | null;
  receiptDateDateTime: string;
  samplingDateTime: string;
  sampledCharacteristics: SampledCharacteristic[];
  isManualEntry: boolean;
  state: StateEnum;
}

export interface TargetValues {
  minimum: number;
  maximum: number;
  evaluation: number;
}

export interface SampledCharacteristic {
  id: number;
  unitOfMeasurement: string;
  value: number;
  designation: string;
  name: string;
  targetValues: TargetValues;
}

export interface SoilAnalysisState {
  soilAnalyses?: SoilAnalysis[];
  selectedFeatureIds?: string[];
  showSoilAnalysisLayer?: boolean;
  defaultSoilAnalyses?: SoilAnalysis[];
  isLoading?: boolean;
}

export interface GetSoilAnalysesResponse {
  soilAnalyses: SoilAnalysis[];
}

export enum StateEnum {
  Draft = 'Draft',
  Active = 'Active',
  InActive = 'InActive',
}

export interface SoilAnalysisLinkedFinalizedEvent {
  customerId: number;
  cropFieldId: number;
}

export enum SoilAnalysisLinkedEvents {
  soilAnalysisLinkedFinalized = 'Arable_SoilAnalysisLinkedFinalized',
}
